module.exports = __webpack_public_path__ + "static/md-af1d5589b8282b588bfa21740945a466.svg";